import { Container } from './Forum.styles';

const Forum = () => {
  return <Container>Coming Soon</Container>;
};

export { Forum };
